/* MUNA PETWEAR · global.js — carrito lateral, contador y utilidades */
(() => {
  const M = window.MUNA || (window.MUNA = {});
  const routes = M.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };

  M.formatMoney = (cents, format = M.moneyFormat || 'S/ {{amount}}') => {
    const value = Number(cents) / 100;
    const fmt = (n, dec, thou, decSep) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? decSep + d : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        default: return fmt(value, 2, ',', '.');
      }
    });
  };

  const drawer = () => document.querySelector('[data-cart-drawer]');
  const page = () => document.querySelector('[data-cart-page]');
  let lastFocus = null;

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function sectionIds() {
    const ids = [];
    const d = drawer(); if (d) ids.push(d.dataset.sectionId);
    const p = page(); if (p) ids.push(p.dataset.sectionId);
    return ids.filter(Boolean);
  }

  function renderSections(sections) {
    if (!sections) return;
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
    const d = drawer();
    if (d && sections[d.dataset.sectionId]) {
      const fresh = parse(sections[d.dataset.sectionId]).querySelector('.drawer__panel');
      if (fresh) d.querySelector('.drawer__panel').innerHTML = fresh.innerHTML;
    }
    const p = page();
    if (p && sections[p.dataset.sectionId]) {
      const fresh = parse(sections[p.dataset.sectionId]).querySelector('[data-cart-page]');
      if (fresh) p.innerHTML = fresh.innerHTML;
    }
  }

  async function refreshCount() {
    try {
      const cart = await fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      setCount(cart.item_count);
      return cart;
    } catch (e) { return null; }
  }

  M.openCart = () => {
    const d = drawer();
    if (!d || M.cartType === 'page') { window.location.href = routes.cart_url; return; }
    lastFocus = document.activeElement;
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open')));
    d.querySelector('.drawer__panel').focus({ preventScroll: true });
  };
  M.closeCart = () => {
    const d = drawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    const panel = d.querySelector('.drawer__panel');
    const done = () => { d.hidden = true; };
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) done(); else panel.addEventListener('transitionend', done, { once: true });
    setTimeout(done, 500);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };

  M.addToCart = async (formData) => {
    const ids = sectionIds();
    if (ids.length) {
      formData.append('sections', ids.join(','));
      formData.append('sections_url', window.location.pathname);
    }
    const res = await fetch(routes.cart_add_url + '.js', {
      method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || (M.strings && M.strings.error));
    renderSections(data.sections);
    await refreshCount();
    return data;
  };

  async function changeLine(line, quantity, scope) {
    scope && scope.classList.add('is-loading');
    try {
      const res = await fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: sectionIds(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description);
      renderSections(data.sections);
      setCount(data.item_count);
    } catch (e) {
      window.location.reload();
    } finally {
      scope && scope.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && drawer() && M.cartType !== 'page') { e.preventDefault(); M.openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); M.closeCart(); return; }
    const qtyBtn = e.target.closest('[data-line-qty]');
    if (qtyBtn) {
      const lineEl = qtyBtn.closest('[data-line]');
      if (!lineEl) return;
      e.preventDefault();
      changeLine(Number(lineEl.dataset.line), Math.max(0, Number(qtyBtn.dataset.lineQty)), lineEl);
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (!input) return;
    const lineEl = input.closest('[data-line]');
    changeLine(Number(lineEl.dataset.line), Math.max(0, parseInt(input.value, 10) || 0), lineEl);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      M.closeCart();
      const menu = document.querySelector('[data-menu][open]');
      if (menu) menu.removeAttribute('open');
    }
    // Mantener el foco dentro del carrito abierto
    if (e.key === 'Tab') {
      const d = drawer();
      if (!d || d.hidden) return;
      const f = d.querySelectorAll('a[href], button:not([disabled]), input');
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  // Cerrar el menú móvil al tocar fuera
  document.addEventListener('click', (e) => {
    const menu = document.querySelector('[data-menu][open]');
    if (menu && (!menu.contains(e.target) || e.target.closest('.header__drawer a'))) menu.removeAttribute('open');
  });
})();
